<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SiteCreate from '../../sites/components/SiteCreate.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: false,
        hideHeader: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <SiteCreate />
</template>